<template>
  <div v-cloak id="printBox" ref="box">
    <appheader index="1"></appheader>
    <div
      class="shoppingCart"
      v-loading="loading"
      :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.7)"
    >
      <div class="shoppingCart_head">
        <div class="cartTitle">
          <p>我的购物车</p>
          <div class="allGoods">全部商品({{ cartNumber }})</div>
          <div class="invalidGoods" @click="goLoseEffectiveness">失效商品</div>
          <div class="networkWrap">
            <el-select
              v-model="sitekey"
              placeholder="请选择网点"
              filterable
              clearable
              v-if="userInfo.comOrganization && userInfo.comOrganization.orgCode"
              @change="onChange"
            >
              <el-option v-for="item in networkList" :key="item.siteId" :label="item.label" :value="item.siteId"> </el-option>
            </el-select>
          </div>
        </div>

        <div class="searchWrap">
          <div class="texureWrap">
            <el-select
              v-model="listQuery.textureList"
              @change="handleTextureChange"
              placeholder="请选择材质"
              multiple
              collapse-tags
              filterable
              clearable
              v-if="textureList.length > 0"
            >
              <el-option v-for="item in textureList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </div>
          <div class="texureWrap">
            <el-select
              collapse-tags
              v-model="listQuery.productCategoryNameList"
              @change="handleCategoryChange"
              multiple
              placeholder="请选择品类"
              filterable
              clearable
              v-if="productCategoryNameList.length > 0"
            >
              <el-option v-for="item in productCategoryNameList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </div>
          <div class="styleNumberWrap">
            <el-input
              placeholder="请输入款号"
              prefix-icon="el-icon-search"
              v-model="listQuery.styleNumber"
              @keyup.enter.native="getsearchCart()"
              clearable
            ></el-input>
          </div>

          <div class="searchClass" @click="getsearchCart()">搜索</div>
          <div class="resetClass" @click="resetSearchCart()">重置</div>
        </div>
      </div>
      <div v-if="shoppingCart.length > 0" ref="barWrap">
        <div v-for="(item, index) in shoppingCart" :key="index">
          <!-- 钻石定单 -->
          <CartDiamondCustom
            ref="cartCustom"
            @updataCart="updataCart"
            :addOrderList="addOrderList"
            v-if="item[0].product.classify == '2'"
            :cycleCustom="item"
          />
          <!-- 素金定单 -->
          <CartPlainGoldCustom
            ref="cartCustom"
            @updataCart="updataCart"
            :addOrderList="addOrderList"
            v-if="item[0].product.classify == '1'"
            :cycleCustom="item"
          />
          <!-- 手表定单 -->
          <CartWatchCustom
            ref="cartCustom"
            @updataCart="updataCart"
            :addOrderList="addOrderList"
            v-if="item[0].product.classify == '3'"
            :cycleCustom="item"
          />
          <!-- 现货足金镶嵌 -->
          <CartGoldsettingCustom
            ref="cartCustom"
            @updataCart="updataCart"
            :addOrderList="addOrderList"
            v-if="item[0].product.classify == '4'"
            :cycleCustom="item"
          />
        </div>
        <p v-if="listLoading" class="listStatus">加载中...</p>
        <p v-else-if="noMore" class="listStatus">没有更多了</p>
      </div>
      <div v-if="shoppingCart.length == 0" style="text-align: center; margin: 60px 0">
        <img src="@/Img/noData.png" alt />
      </div>
      <div :class="navBarFixed == true ? 'cartNavBarWrap' : 'navBarNo'" ref="navBar">
        <div class="selectBox">
          <div class="selectBox_left">
            <div class="selectAll">
              <el-checkbox v-model="spotData" @change="spotAll"></el-checkbox>
            </div>
            <div class="selectText">现货全选</div>
          </div>
          <div class="selectBox_left" v-if="hasMainBodyType()[0].value !== '2'">
            <div class="selectAll">
              <el-checkbox v-model="customData" @change="customAll"></el-checkbox>
            </div>
            <div class="selectText">定单全选</div>
          </div>
        </div>
        <div class="modifyBox">
          <div class="price-class">预估价格，实际价格请以结算为准</div>
          <div class="modifyBox_left">
            <div class="selectAll">
              <el-checkbox v-model="checkedData" @change="ZlfAllproducts"></el-checkbox>
            </div>
            <div class="ckeckAll">全选</div>
            <div class="deleteAll" @click="showdetailbox">删除</div>
          </div>
          <div class="modifyBox_right">
            <div class="selectedNumber">
              已选<span class="selectedInterval">{{ shangp }}</span
              >件商品
            </div>
            <div class="selectedNumber">
              (现货
              <div class="selectedInterval">{{ spotNumber }}</div>
              件<span v-if="hasMainBodyType()[0].value !== '2'"
                >,定单 <span class="selectedInterval">{{ comtosNumber }}</span> <span>件</span> </span
              >)
            </div>
            <div class="selectedNumber">
              标签总金额:
              <div class="selectedInterval">
                {{ shopCarPrice }}
              </div>
            </div>
            <div class="selectedNumber" v-if="!hasPermission('展厅') || !hasPermission('加盟公司总经理') || !hasPermission('业务-数据查询')">
              结算总金额:
              <div class="selectedInterval">
                {{ wholesalePrice }}
              </div>
            </div>
            <div class="selectedNumber" v-if="!hasPermission('展厅') || !hasPermission('加盟公司总经理') || !hasPermission('业务-数据查询')">
              结算总工费:
              <div class="selectedInterval">
                {{ settleTotalLaborCost }}
              </div>
            </div>
            <div class="selectedNumber" v-if="totalGoldWeight && !totalCustomGoldWeight">
              现货素金总金重:
              <div class="selectedInterval">{{ totalGoldWeight }}g</div>
            </div>
            <div class="selectedNumber" v-if="totalCustomGoldWeight && !totalGoldWeight">
              定单素金总金重:
              <div class="selectedInterval">{{ totalCustomGoldWeight }}g</div>
            </div>
            <div class="selectedNumber" v-if="totalCustomGoldWeight && totalGoldWeight">
              现货+定单素金总金重:
              <div class="selectedInterval">{{ totalWeight }}g</div>
            </div>
            <div class="submitOrder" @click="submitOrder">提&nbsp;&nbsp;交</div>
          </div>
        </div>
      </div>
    </div>
    <SubmitDialog
      v-if="submitDialogVisible"
      :submitDialogVisible="submitDialogVisible"
      @onCloseSelectDialog="onCloseSelectDialog"
      @placeOrder="placeOrder"
    />
    <!-- 删除确认弹窗 -->
    <ConfirmDeletion
      v-if="deletingPopoversVisible"
      :deletingPopoversVisible="deletingPopoversVisible"
      @onCloseSelectDialog="onCloseSelectDialog"
      @confirmDel="confirmDel"
    />
    <bottom ref="bottomRef"></bottom>
  </div>
</template>

<script>
import Appheader from '../moudel/Appheader';
import bottom from '../bady_bottom/bottom';
import { Decimal } from 'decimal.js';
import { cartListData, modifyCartPublic, pushOrder, getNetworkList, getDistinctTextures, getDistinctCategoryNames } from '@/api/cartApi';
import CartWatchCustom from './components/custom/CartWatchCustom.vue';
import CartDiamondCustom from './components/custom/CartDiamondCustom.vue';
import CartPlainGoldCustom from './components/custom/CartPlainGoldCustom.vue';
import CartGoldsettingCustom from './components/custom/CartGoldsettingCustom.vue';
import SubmitDialog from './components/submit/SubmitDialog.vue';
import ConfirmDeletion from './components/updata/ConfirmDeletion.vue';
import { deepClone } from '@/utils/util';
import { getComputed, getHandleList } from '@/utils/computed';
import ls from '@/utils/localStorage';
export default {
  components: {
    Appheader,
    bottom,
    CartWatchCustom,
    CartDiamondCustom,
    CartPlainGoldCustom,
    SubmitDialog,
    ConfirmDeletion,
    CartGoldsettingCustom,
  },
  data() {
    const allOptionValue = '';
    return {
      allOptionValue,
      noOrders: false,
      submitDialogVisible: false,
      deletingPopoversVisible: false,
      shoppingCart: [],
      addOrderList: [],
      idList: [],
      total: 0,
      navBarFixed: false,
      loading: false,
      loadingText: '正在加载购物车',
      listLoading: false,
      appendSelectionState: null,
      listCode: [], //现货售完
      customMadeCode: [], //定单售完
      listQuery: {
        size: 10,
        current: 1,
        styleNumber: '',
        requestFrom: 1,
        siteId: '',
        orgCode: '',
        pageType: '',
        textureList: [],
        productCategoryNameList: [],
      },
      lastTextureSelection: [],
      lastCategorySelection: [],
      productCategoryNameList: [],
      textureList: [],
      sitekey: '',
      userInfo: {},
      networkList: [],
    };
  },
  computed: {
    // 所有全选
    checkedData: {
      get() {
        return getComputed(this.shoppingCart, 'checkedData');
      },
      set() {
        return getComputed(this.shoppingCart, 'checkedData');
      },
    },
    // 现货全选
    spotData: {
      get() {
        return getComputed(this.shoppingCart, 'spot');
      },
      set() {
        return getComputed(this.shoppingCart, 'spot');
      },
    },
    // 定单全选
    customData: {
      get() {
        return getComputed(this.shoppingCart, 'customData');
      },
      set() {
        return getComputed(this.shoppingCart, 'customData');
      },
    },
    // 全部商品
    cartNumber: function () {
      return getComputed(this.shoppingCart, 'cartNumber');
    },
    // 总商品数量
    shangp: function () {
      return getComputed(this.shoppingCart, 'shangp');
    },
    // 现货商品数量
    spotNumber: function () {
      return getComputed(this.shoppingCart, 'spotNumber');
    },
    //预定商品数量
    comtosNumber: function () {
      return getComputed(this.shoppingCart, 'comtosNumber');
    },
    // 购物车结算总金额
    wholesalePrice: function () {
      return getComputed(this.shoppingCart, 'wholesalePrice');
    },
    // 购物车结算工费
    settleTotalLaborCost: function () {
      return getComputed(this.shoppingCart, 'settleTotalLaborCost');
    },
    // 购物车标签总金额
    shopCarPrice: function () {
      return getComputed(this.shoppingCart, 'shopCarPrice');
    },
    // 购物车 素金现货总金重 spotFlag 1为现货2为定制
    totalGoldWeight: function () {
      return getComputed(this.shoppingCart, 'totalGoldWeight');
    },
    // 购物车素金订单总金重
    totalCustomGoldWeight: function () {
      return getComputed(this.shoppingCart, 'totalCustomGoldWeight');
    },
    // 现货定制素金合计
    totalWeight: function () {
      return new Decimal(this.totalGoldWeight).add(new Decimal(this.totalCustomGoldWeight));
    },
    noMore() {
      return this.total > 0 && this.addOrderList.length >= this.total;
    },
  },
  mounted() {
    this.listQuery.siteId = ls.get('siteId') || ls.get('userInfo').comOrganization?.id || 0;
    this.listQuery.orgCode = ls.get('userInfo').comOrganization?.orgCode ? ls.get('userInfo').comOrganization?.orgCode : 0;
    this.userInfo = ls.get('userInfo');
    this.fetchNetworkList();
    // 购物车查看
    this.refreshList();
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll);
  },
  methods: {
    normalizeAllSelection(valueList = [], previousValueList = []) {
      const hasAll = valueList.includes(this.allOptionValue);
      const hadAll = previousValueList.includes(this.allOptionValue);

      if (!valueList.length) {
        return [];
      }

      if (hasAll && !hadAll) {
        return [this.allOptionValue];
      }

      if (hasAll && hadAll && valueList.length > 1) {
        return valueList.filter((item) => item !== this.allOptionValue);
      }

      return valueList;
    },
    handleTextureChange(value) {
      this.listQuery.textureList = this.normalizeAllSelection(value, this.lastTextureSelection);
      this.lastTextureSelection = [...this.listQuery.textureList];
    },
    handleCategoryChange(value) {
      this.listQuery.productCategoryNameList = this.normalizeAllSelection(value, this.lastCategorySelection);
      this.lastCategorySelection = [...this.listQuery.productCategoryNameList];
    },
    getRequestListQuery() {
      return {
        ...this.listQuery,
        textureList: this.listQuery.textureList.includes(this.allOptionValue) ? [] : this.listQuery.textureList,
        productCategoryNameList: this.listQuery.productCategoryNameList.includes(this.allOptionValue) ? [] : this.listQuery.productCategoryNameList,
      };
    },
    fetchDistinctTextures() {
      return getDistinctTextures(this.listQuery.siteId).then((res) => {
        this.textureList = res.data || [];
        return res;
      });
    },
    fetchDistinctCategoryNames() {
      return getDistinctCategoryNames(this.listQuery.siteId).then((res) => {
        this.productCategoryNameList = res.data || [];
        return res;
      });
    },
    onChange(value) {
      if (this.listQuery.siteId != value) {
        ls.set('siteId', value);
        this.listQuery.siteId = value;
        this.networkList.forEach((ely) => {
          if (ls.get('siteId') == ely.siteId) {
            ls.set('orgCode', ely.orgCode);
            this.listQuery.orgCode = ely.orgCode;
          }
        });
        this.refreshList();
        // store.dispatch('GetStandard').then(() => {});
      }
    },
    // 获取所有网点
    fetchNetworkList() {
      const params = {
        type: 1, // 获取不要机构的网点接口, type=1
        isAllNetwork: false, // true公司下的所有网点 false当前账号的所有网点
        isHead: false, // 周六福总部 true显示 false不显示
        typeList: 'S',
        status: 'o',
        size: 200,
        current: 1,
      };
      getNetworkList(params).then((res) => {
        res.data?.records?.forEach((item) => {
          const obj = {
            siteId: item.id,
            orgCode: item.orgCode,
            frontName: item.shortName || item.orgName,
            label: `[${item.orgCode}]${item.shortName || item.orgName}`,
          };
          this.networkList.push(obj);
        });
        if (
          this.networkList.findIndex((item) => item.siteId == ls.get('userInfo').comOrganization?.id) === -1 &&
          ls.get('userInfo').comOrganization?.id
        ) {
          this.networkList.unshift({
            siteId: ls.get('userInfo').comOrganization?.id,
            orgCode: ls.get('userInfo').comOrganization?.orgCode,
            frontName: ls.get('userInfo').comOrganization?.shortName || ls.get('userInfo').comOrganization?.orgName,
            label: `[${ls.get('userInfo').comOrganization?.orgCode}]${
              ls.get('userInfo').comOrganization?.shortName || ls.get('userInfo').comOrganization?.orgName
            }`,
          });
        }
        if (!ls.get('siteId')) {
          ls.set('siteId', ls.get('userInfo').comOrganization?.id);
          ls.set('orgCode', this.networkList[0].orgCode);
          this.sitekey = `[${this.networkList[0].orgCode}]${this.networkList[0].frontName}`;
        } else {
          this.networkList.forEach((ely) => {
            if (ls.get('siteId') == ely.siteId) {
              this.sitekey = `[${ely.orgCode}]${ely.frontName}`;
              ls.set('orgCode', ely.orgCode);
            }
          });
        }
      });
    },
    // 跳转失效商品页面
    goLoseEffectiveness() {
      this.$router.push('/invalidGoods');
    },
    // 关闭弹窗
    onCloseSelectDialog() {
      this.deletingPopoversVisible = false;
      this.submitDialogVisible = false;
      this.refreshList();
    },
    // 操作完刷新购物车列表
    updataCart() {
      this.refreshList();
    },
    getCartCustomRefs() {
      if (!this.$refs.cartCustom) {
        return [];
      }
      return Array.isArray(this.$refs.cartCustom) ? this.$refs.cartCustom : [this.$refs.cartCustom];
    },
    setAppendSelectionState(selectionState) {
      this.appendSelectionState = selectionState;
    },
    captureAppendSelectionState() {
      this.setAppendSelectionState({
        checkedData: this.checkedData,
        spotData: this.spotData,
        customData: this.customData,
      });
    },
    applyAppendSelectionState() {
      if (!this.appendSelectionState) {
        return;
      }
      const selectionState = this.appendSelectionState;
      this.appendSelectionState = null;
      if (selectionState.checkedData) {
        this.ZlfAllproducts(true);
        return;
      }
      if (selectionState.spotData) {
        this.spotAll(true);
      }
      if (selectionState.customData) {
        this.customAll(true);
      }
    },
    applySpotSelection(e) {
      if (e) {
        this.shoppingCart = this.shoppingCart.map((val) => {
          val.map((res) => {
            res.cartList.forEach((ele) => {
              if (ele.spotFlag == 1) {
                if (ele.cartStatus === '现货') {
                  ele.switchFlag = true;
                } else {
                  ele.switchFlag = false;
                }
                val.flag = res.cartList.every((val) => val.switchFlag == true);
              }
            });
          });
          return val;
        });
      } else {
        this.shoppingCart = this.shoppingCart.map((val) => {
          val.map((res) => {
            res.cartList.forEach((ele) => {
              if (ele.spotFlag == 1) {
                ele.switchFlag = false;
                val.flag = false;
              }
            });
          });
          return val;
        });
      }
    },
    applyCustomSelection(e) {
      this.getCartCustomRefs().forEach((res) => {
        if (res.cycleCustom[0]?.spotFlag == 2) {
          res.cycleCustom.flag = e;
          res.onChange(e);
        }
      });
    },
    refreshList(scrollToTop = false, withLoading = true) {
      this.listQuery.current = 1;
      this.listLoading = false;
      this.appendSelectionState = null;
      if (scrollToTop) {
        window.scrollTo(0, 0);
      }
      return this.getList(withLoading, true);
    },
    // 获取列表数据
    getList(withLoading = true, isReload = false) {
      if (withLoading) {
        this.loading = true;
        this.loadingText = '正在加载购物车';
      }

      return Promise.all([
        cartListData(this.getRequestListQuery()),
        this.fetchDistinctTextures().catch(() => null),
        this.fetchDistinctCategoryNames().catch(() => null),
      ])
        .then(([res]) => {
          const records = res.data.records || [];
          const clonedRecords = deepClone(records);
          const handledRecords = getHandleList(records);
          if (isReload || this.listQuery.current === 1) {
            this.addOrderList = clonedRecords;
            this.shoppingCart = handledRecords;
          } else {
            this.addOrderList = [...this.addOrderList, ...clonedRecords];
            this.shoppingCart = [...this.shoppingCart, ...handledRecords];
          }
          this.total = res.data.total || 0;
          this.$forceUpdate();
        })
        .finally(() => {
          this.listLoading = false;
          this.$nextTick(() => {
            if (!isReload && this.listQuery.current > 1) {
              this.applyAppendSelectionState();
            }
            this.syncNavBar();
            this.ensureScrollableContent();
          });
          if (withLoading) {
            this.loading = false;
            this.loadingText = '正在加载购物车';
          }
        });
    },
    load() {
      if (this.loading || this.listLoading || this.noMore) {
        return Promise.resolve();
      }
      this.captureAppendSelectionState();
      this.listQuery.current += 1;
      this.listLoading = true;
      return this.getList(false).catch((err) => {
        this.listQuery.current -= 1;
        throw err;
      });
    },
    syncNavBar() {
      const barWrap = this.$refs.barWrap;
      if (!barWrap) {
        this.navBarFixed = false;
        return;
      }
      this.navBarFixed = barWrap.getBoundingClientRect().bottom > document.documentElement.clientHeight;
    },
    shouldLoadMore() {
      if (this.loading || this.listLoading || this.noMore) {
        return false;
      }
      const barWrap = this.$refs.barWrap;
      if (!barWrap) {
        return false;
      }
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const navBarHeight = this.navBarFixed ? this.$refs.navBar?.getBoundingClientRect().height || 0 : 0;
      return barWrap.getBoundingClientRect().bottom <= viewportHeight + navBarHeight + 200;
    },
    ensureScrollableContent() {
      if (this.shouldLoadMore()) {
        this.load();
      }
    },
    // 判断底部提交按钮距离底部的距离
    watchScroll() {
      this.syncNavBar();
      if (this.shouldLoadMore()) {
        this.load();
      }
    },
    // 购物车搜索
    getsearchCart() {
      this.refreshList(true);
    },
    // 重置搜索条件
    resetSearchCart() {
      this.listQuery.current = 1;
      this.listQuery.styleNumber = '';
      this.listQuery.textureList = [];
      this.listQuery.productCategoryNameList = [];
      this.lastTextureSelection = [...this.listQuery.textureList];
      this.lastCategorySelection = [...this.listQuery.productCategoryNameList];
      this.refreshList(true);
    },
    // 鼠标移出
    imgLeave() {
      this.shutDown();
    },
    // 确认删除
    confirmDel() {
      let delList = [];
      this.idList.forEach((res) => {
        let obj = {
          id: res.id,
          sequences: res.sequenceList,
        };
        delList.push(obj);
      });
      this.loading = true;
      this.loadingText = '正在删除商品';
      modifyCartPublic(delList, 'delete')
        .then((res) => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 1500,
            });
            this.deletingPopoversVisible = false;
            return this.refreshList(false, false);
          }
        })
        .finally(() => {
          this.loading = false;
          this.loadingText = '正在加载购物车';
        });
    },
    // 购物车删除按钮
    showdetailbox() {
      this.idList = [];
      let idS = [];
      this.shoppingCart.forEach((res) => {
        res.forEach((item) => {
          item.cartList.forEach((ele) => {
            if (ele.switchFlag) {
              if (!idS.includes(ele)) {
                idS.push(ele);
              }
            }
          });
        });
      });
      this.addOrderList.forEach((res) => {
        res.forEach((item) => {
          item.cartList.forEach((ele) => {
            idS.forEach((ally) => {
              // 钻石现货
              if (ally.classify == '2' && ally.spotFlag == 1 && ally.gender) {
                if (ele.id === ally.id && ele.texture === ally.texture && ele.gender === ally.gender) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele);
                  }
                }
              } else if (ally.spotFlag == 1) {
                if (ele.id === ally.id) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele);
                  }
                }
              } else {
                if (ele.id === ally.id && ele.sequence === ally.sequence) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele);
                  }
                }
              }
            });
          });
        });
      });
      if (this.idList.length <= 0) {
        this.$message({
          message: '至少选择一条商品删除',
          type: 'warning',
          duration: 1500,
        });
      } else {
        this.deletingPopoversVisible = true;
      }
    },
    // 确定下单
    placeOrder(from) {
      let orderInfor = deepClone(from);
      delete orderInfor.organizationList;
      orderInfor.cartRequestDtoList = [];
      // 修改bug
      if (orderInfor.netAddress?.indexOf('-') > 0) {
        orderInfor.netCode = from.netAddress.split('-')[0];
        orderInfor.netAddress = from.netAddress.split('-')[1];
      } else {
        orderInfor.netCode = '';
        orderInfor.netAddress = '';
      }
      orderInfor.sourceType = 1;
      orderInfor.orderPath = 1;
      orderInfor.requestFrom = 1;
      this.idList.forEach((res) => {
        let obj = {
          id: res.id,
          sequences: res.sequenceList,
        };
        orderInfor.cartRequestDtoList.push(obj);
      });
      pushOrder(orderInfor)
        .then((res) => {
          if (res.code === 0) {
            this.submitDialogVisible = false;
            this.$confirm('提交成功', '提示', {
              confirmButtonText: '继续下单',
              cancelButtonText: '查看订单',
              type: 'success',
            })
              .then(() => {
                this.refreshList();
                this.idList = [];
              })
              .catch(() => {
                this.idList = [];
                this.$router.push('/CommodityOrder');
              });
          }
        })
        .catch((err) => {
          if (err === '存在已售或下架商品') {
            this.submitDialogVisible = false;
            this.refreshList();
          }
        });
    },
    // 购物车下单按钮
    submitOrder() {
      this.idList = [];
      let idS = [];
      this.shoppingCart.forEach((res) => {
        res.forEach((item) => {
          item.cartList.forEach((ele) => {
            if (ele.switchFlag) {
              if (!idS.includes(ele)) {
                idS.push(ele);
              }
            }
          });
        });
      });
      this.addOrderList.forEach((res) => {
        res.forEach((item) => {
          item.cartList.forEach((ele) => {
            idS.forEach((ally) => {
              // 钻石现货
              if (ally.classify == '2' && ally.spotFlag == 1 && ally.gender) {
                if (ele.id === ally.id && ele.texture === ally.texture && ele.gender === ally.gender) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele);
                  }
                }
                // 素金现货
              } else if (ally.classify == '1' && ally.spotFlag == 1 && ally.gender) {
                if (ele.id === ally.id && ele.gender === ally.gender) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele);
                  }
                }
              } else if (ally.spotFlag == 1) {
                if (ele.id === ally.id) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele);
                  }
                }
              } else {
                if (ele.id === ally.id && ele.sequence === ally.sequence) {
                  if (!this.idList.includes(ele)) {
                    this.idList.push(ele);
                  }
                }
              }
            });
          });
        });
      });
      if (this.idList.length <= 0) {
        this.$message({
          message: '至少选择一条商品下单',
          type: 'warning',
          duration: 1500,
        });
      } else {
        this.submitDialogVisible = true;
      }
    },
    // 商品全选
    ZlfAllproducts(e) {
      if (this.listLoading) {
        this.setAppendSelectionState({
          checkedData: e,
          spotData: e,
          customData: e,
        });
      }
      this.applySpotSelection(e);
      this.applyCustomSelection(e);
      this.$forceUpdate();
    },
    // 现货全选
    spotAll(e, fromAll = false) {
      if (this.listLoading && !fromAll) {
        this.setAppendSelectionState({
          checkedData: false,
          spotData: e,
          customData: this.customData,
        });
      }
      this.applySpotSelection(e);
      this.$forceUpdate();
    },
    // 定单全选
    customAll(e, fromAll = false) {
      if (this.listLoading && !fromAll) {
        this.setAppendSelectionState({
          checkedData: false,
          spotData: this.spotData,
          customData: e,
        });
      }
      this.applyCustomSelection(e);
      this.$forceUpdate();
    },
  },
  // 离开页面清除监听事件
  beforeDestroy() {
    window.removeEventListener('scroll', this.watchScroll);
  },
};
</script>
<style lang="scss" scoped>
.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  cursor: not-allowed !important;
  background-image: none !important;
  border: none !important;
  background: #c8c9cc !important;
  color: #fff !important;
}

.mainStoneSizeClass {
  width: 78px !important;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-right: 1px solid #ec9368;
}

#printBox {
  background: #f3f3f3;
}

.shoppingCart_head .el-input {
  display: block;
}

.shoppingCart_head ::v-deep .el-input__inner {
  border: 1px solid #ec9368;
  border-radius: 30px !important;
}

.shoppingCart_head ::v-deep .el-input__icon {
  height: 33px !important;
  line-height: 33px !important;
}

.shoppingCart {
  max-width: 1500px;
  margin: 0 auto;
  min-height: 880px;
  background: #fff;

  .invalidGoods {
    color: #fff;
    background: red;
    font-size: 14px;
    width: 100px;
    text-align: center;
    padding: 5px 0;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 10px;
  }
  .networkWrap {
    margin-left: 15px;
    .el-select {
      width: 250px;
    }
  }
  .texureWrap {
    margin-left: 15px;
    .el-select {
      width: 210px;
    }
    /deep/ .el-input__inner {
      height: auto !important;
      min-height: 33px !important;
      line-height: 20px !important;
      padding-top: 4px !important;
      padding-bottom: 4px !important;
    }
    /deep/ .el-select__tags {
      flex-wrap: wrap;
      max-width: calc(100% - 32px);
    }
    /deep/ .el-tag {
      margin-bottom: 4px;
    }
  }
  .styleNumberWrap {
    margin-left: 10px;
    /deep/ .el-input__inner {
      width: 150px;
    }
  }
  .searchWrap {
    display: flex;
    align-items: flex-start;
    margin-top: 34px;
  }
  .shoppingCart_head {
    display: flex;
    justify-content: space-between;
    margin: 0 10px;
  }

  .shoppingCart_bodyFather {
    border: 1px solid #ede2ce;
    margin-top: 12px;

    .activeBack {
      background: red;
    }

    .shoppingCart_body {
      width: 100%;
      min-height: 105px;
      display: flex;
      font-size: 0;
      position: relative;

      .shoppingCart_body_child {
        display: flex;
        align-items: center;
        position: relative;

        img {
          width: 70px;
          height: 70px;
          cursor: pointer;
        }
      }

      .el-divider--horizontal {
        display: block;
        height: 1px;
        width: 100%;
        margin: 24px 0;
      }
    }
  }

  .selectBox {
    display: flex;
    align-items: center;
    margin: 30px 0 10px 0;

    .selectBox_left {
      display: flex;
      align-items: center;

      .selectText {
        color: #000000;
        margin-right: 40px;
        font-size: 20px;
      }
    }

    ::v-deep .el-checkbox__input {
      vertical-align: inherit;
    }

    ::v-deep .el-checkbox__inner {
      width: 16px !important;
      height: 16px !important;
    }

    ::v-deep .el-checkbox__inner::after {
      height: 9px !important;
      left: 5px !important;
      top: 0px !important;
      width: 3px !important;
    }

    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #ec9368;
      border-color: #ec9368;
    }

    ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #dcdfe6 !important;
    }

    ::v-deep .el-checkbox__inner:hover {
      border-color: #ec9368 !important;
    }

    ::v-deep .el-checkbox__inner:focus {
      border-color: #ec9368 !important;
    }
  }

  .selectAll {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  .modifyBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .price-class {
      color: red;
      position: absolute;
      top: 0;
      right: 162px;
    }
    .modifyBox_left {
      display: flex;
      // font-size: 24px;
      align-items: center;
      height: 66px;

      ::v-deep .el-checkbox__input {
        vertical-align: inherit;
      }

      ::v-deep .el-checkbox__inner {
        width: 16px !important;
        height: 16px !important;
      }

      ::v-deep .el-checkbox__inner::after {
        height: 9px !important;
        left: 5px !important;
        top: 0px !important;
        width: 3px !important;
      }

      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #ec9368;
        border-color: #ec9368;
      }

      ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #dcdfe6 !important;
      }

      ::v-deep .el-checkbox__inner:hover {
        border-color: #ec9368 !important;
      }

      ::v-deep .el-checkbox__inner:focus {
        border-color: #ec9368 !important;
      }

      .ckeckAll {
        color: #000000;
        margin-right: 40px;
        font-size: 24px;
      }

      .deleteAll {
        color: #ff0000;
        font-size: 24px;
        cursor: pointer;
        z-index: 1;
      }
    }

    .modifyBox_right {
      display: flex;
      font-size: 16px;
      align-items: center;
    }

    .selectedNumber {
      display: flex;
      margin-right: 15px;
      align-items: baseline;
    }

    .selectedInterval {
      color: #ec9368;
      margin: 0 5px;
    }

    .submitOrder {
      color: #fff;
      width: 140px;
      height: 66px;
      text-align: center;
      line-height: 66px;
      background: #ec9368;
      cursor: pointer;
    }
  }

  .listStatus {
    color: #999;
    font-size: 14px;
    text-align: center;
    padding: 20px 0 8px;
  }
}

.el-select-dropdown__item {
  width: 97%;
}
</style>
<style scope>
.shoppingCart_head .el-input__inner {
  height: 33px !important;
  line-height: 33px !important;
}

.cartTitle {
  font-size: 24px;
  color: #000;
  margin-top: 34px;
  display: flex;
  align-items: center;
}

.allGoods {
  font-size: 22px;
  color: #ec9368;
  margin-left: 10px;
}

.cartNavBarWrap {
  position: fixed;
  bottom: 0;
  left: 50%;
  padding-bottom: 20px;
  transform: translate(-50%, 0);
  z-index: 999;
  background: #fff;
  width: 100%;
  max-width: 1480px;
  padding: 10px;
}

.navBarNo {
  max-width: 1480px;
  width: 100%;
  background: #fff;
  padding: 10px;
}

.bottomBox .el-button--primary {
  background: #ec9368 !important;
  border-color: #ec9368 !important;
}

.bottomBox .el-button--primary:focus {
  border: none !important;
}

.bottomBox {
  width: 380px;
  border: 1px solid #ec9368;
  margin: 0 auto;
}

.bottomBox .el-button--primary:hover {
  width: 380px !important;
  border-radius: 0;
}

.el-button {
  border-radius: 0 !important;
}

.searchClass,
.resetClass {
  height: 33px;
  line-height: 33px;
  width: 60px;
  text-align: center;
  font-size: 16px;
  border-radius: 30px;
  margin-left: 10px;
  cursor: pointer;
  box-sizing: border-box;
}

.searchClass {
  background: #ec9368;
  color: #fff;
}

.resetClass {
  border: 1px solid #ec9368;
  color: #ec9368;
  background: #fff;
}
/* 表格数据为空时显示——*/
.tableData :empty::before {
  content: '-';
}
</style>
